import configureAxios from 'configure/axios';

const axios = configureAxios();

export const login = (email, password, recaptcha_token, device_uuid, verification_code, code_sending_mode, target_mdn) => axios.post('users/login/', {
  email,
  password,
  recaptcha_token,
  device_uid: device_uuid,
  device_verification_code: verification_code,
  code_sending_mode,
  target_mdn,
});
